import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  ChatState,
  changeCurrTab,
  currTabChatSelector,
  tabsChatSelector,
} from "@/domains/chat/slice";
import useSetDefaultCommandByTab from "@/domains/chat/hooks/useSetDefaultCommandByTab";
import ChatTabs from "@/domains/chat/components/chat/ChatTabs";

export default function ChatTabsContainer() {
  useSetDefaultCommandByTab();
  const dispatch = useAppDispatch();
  const tabs = useAppSelector(tabsChatSelector);
  const currTab = useAppSelector(currTabChatSelector);

  const changeTab = useCallback(
    (value: ChatState["currTab"]) => {
      dispatch(changeCurrTab(value));
    },
    [dispatch],
  );

  return <ChatTabs tabs={tabs} currTab={currTab} changeTab={changeTab} />;
}
